import React from 'react';
import PropTypes from 'prop-types';

import { Col } from 'reactstrap';
import './styles.scss';

const dataWidget = props => {
  const { title, value, unit, oldValue, size = 4 } = props;
  const trend = oldValue > value === true ? 'up' : 'down';
  return (
    <Col sm={size} md={size}>
      <div className="element-box el-tablo">
        <div className="label">{title}</div>
        <div className="value">{unit}{value.toLocaleString('it')}</div>
        {oldValue > 0 && (
          <div className={`trending trending-${trend}-basic`}>
            <span>{ Math.round(value / oldValue * 100) }%</span>
            {oldValue >= value ? (
              <i className="os-icon os-icon-arrow-up2" />
            ) : (
              <i className="os-icon os-icon-arrow-down" />
            )}
          </div>
        )}

      </div>
    </Col>
  );
};

dataWidget.defaultProps = {
  value: 0,
  oldValue: 0,
  unit: '€',
};

dataWidget.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.any,
  unit: PropTypes.string,
  oldValue: PropTypes.number,
  size: PropTypes.number,
};

export default dataWidget;
